import React, { useRef } from 'react';
import { Popover, PopoverAnchor, PopoverContent } from '../ui/popover';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * Tarjeta flotante junto a lo que se pulsó (detalle de un evento, creación rápida). Se ancla a un rectángulo
 * de pantalla (`rect`), no a un elemento: los bloques del calendario se vuelven a pintar al recargar y un ancla
 * a un nodo desaparecido dejaría la tarjeta en la esquina. En el teléfono es una ventana centrada.
 * Sin `rect` (enlace profundo) también va centrada.
 */
export default function Flotante({ rect, abierto, onCerrar, children, ancho = 400, titulo = 'Evento', testId }) {
  const movil = useIsMobile(640);
  const tarjeta = useRef(null);
  const origen = useRef(null);
  if (!abierto) return null;
  /* Teclado (K6, auditoría 2026-10-05): antes el foco se quedaba en el bloque del evento y Editar,
     Eliminar o Responder no se alcanzaban con Tab. Ahora la tarjeta toma el foco (sin borde: es el
     contenedor) y al cerrarse lo devuelve a lo que estaba enfocado antes. */
  const alAbrir = (e) => {
    e.preventDefault();
    origen.current = document.activeElement;
    tarjeta.current?.focus({ preventScroll: true });
  };
  const alCerrar = (e) => {
    e.preventDefault();
    try { origen.current?.focus?.({ preventScroll: true }); } catch (_) { /* ya no está */ }
  };
  if (movil || !rect) {
    return (
      <Dialog open onOpenChange={(v) => { if (!v) onCerrar(); }}>
        <DialogContent ref={tarjeta} tabIndex={-1} className="cal-flotante cal-flotante--dialogo p-0 gap-0 outline-none [&>button.absolute]:hidden" style={{ maxWidth: Math.min(ancho + 40, 520) }} onOpenAutoFocus={alAbrir} onCloseAutoFocus={alCerrar} data-testid={testId}>
          <DialogTitle className="sr-only">{titulo}</DialogTitle>
          {children}
        </DialogContent>
      </Dialog>
    );
  }
  return (
    <Popover open onOpenChange={(v) => { if (!v) onCerrar(); }}>
      <PopoverAnchor asChild>
        <span
          aria-hidden="true"
          style={{ position: 'fixed', left: rect.left, top: rect.top, width: Math.max(1, rect.width), height: Math.max(1, rect.height), pointerEvents: 'none' }}
        />
      </PopoverAnchor>
      <PopoverContent
        side="right"
        align="start"
        sideOffset={8}
        collisionPadding={12}
        ref={tarjeta}
        tabIndex={-1}
        role="dialog"
        aria-label={titulo}
        className="cal-flotante p-0 outline-none"
        style={{ width: ancho }}
        onOpenAutoFocus={alAbrir}
        onCloseAutoFocus={alCerrar}
        data-testid={testId}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
